import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { pageMap } from '../../../core/routing/mapping/page-mapping';
import { NavigationWrapper } from '../../../core/routing/navigation-data';
import { PageKey } from '../../../core/routing/page-keys';
import { take } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserModel } from '../../../core/models/user/user.model';
import { ShiveRoutes } from '../../../core/routing/segments/route-segments';
import { faBusinessTime, faChairOffice, faLocationDot } from '@fortawesome/pro-regular-svg-icons';
import { UserDataService } from '../state-and-data-handling/user-data.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  standalone: false,
})
export class UserProfileComponent implements OnInit {
  public tabs: NavigationWrapper[] = [];
  public userFullName = '';
  public readonly faChairOffice = faChairOffice;
  public readonly faLocationDot = faLocationDot;
  public readonly faBusinessTime = faBusinessTime;
  private readonly userDataService = inject(UserDataService);

  constructor(private readonly activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.activatedRoute.data
      .pipe(
        take(1),
        map((data) => data.user),
      )
      .subscribe((user: UserModel) => {
        this.userDataService.addUser(user);
        this.userFullName = `${user.firstName} ${user.lastName}`; // Todo: Put this into a pipe.
      });

    this.activatedRoute.firstChild!.params.pipe(take(1)).subscribe((params) => {
      const id = params.id;

      const navBaseData = pageMap.get(PageKey.UserProfilePageKeys.UserProfileEdit)!;
      const navAttachments = pageMap.get(PageKey.UserProfilePageKeys.UserProfileAttachments)!;

      const baseDataNavItem = {
        ...navBaseData,
        route: navBaseData.route.replace(ShiveRoutes.AnyId, id),
      };

      const attachmentsNavItem = {
        ...navAttachments,
        route: navAttachments.route.replace(ShiveRoutes.AnyId, id),
      };

      this.tabs = [baseDataNavItem, attachmentsNavItem];
    });
  }
}
